import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { withRouter } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem 0",
  },
  heading: {
    marginBottom: "1rem",
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    // display: 'flex',
    // flexDirection: 'row',
    // justifyContent: "space-between",
    // width: '100%',
  },
}));

const AssignmentProgramModal = (props) => {
  const { isOpen, onClose, currentSelection } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <Dialog
        PaperProps={{
          style: { borderRadius: "20px", width: "38.625rem" },
        }}
        fullWidth={true}
        maxWidth={"md"}
        open={isOpen}
        onClose={onClose}
        aria-labelledby="max-width-dialog-title"
      >
        <div className={classes.root}>
          <div>
            <Typography variant="subtitle1">
              Coaching program created
            </Typography>
          </div>
          <div className={classes.heading}>
            <FormControlLabel
              control={<Checkbox name="" color="primary" />}
              label={
                <Typography variant="h2">
                  Add this program to master templates
                </Typography>
              }
            />
          </div>
          <Grid container item xs={12} className={classes.footer}>
            <Grid item xs={3}>
              <Button
                disableElevation
                onClick={() => {
                  props.history.push("/ManageInfo");
                }}
                variant="outlined"
              >
                Go to MI page
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                disableElevation
                onClick={() => {
                  props.history.push({
                    pathname: "/assignmentoverview",
                    state: {
                      currentAssignment: {
                        id: currentSelection?.id,
                        name: currentSelection?.value,
                      },
                    },
                  });
                  props?.handleClose();
                }}
                variant="outlined"
              >
                Go to assignment overview page
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default withRouter(AssignmentProgramModal);
